import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const NavigationCard = ({ 
  to, 
  title, 
  description, 
  icon = null, 
  isActive, 
  badge, 
  badgeText,
  onClick
}) => {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`group relative p-4 rounded-xl border ${
        isActive
          ? 'bg-[#141414] border-gray-700 text-white shadow-md'
          : 'bg-white border-gray-100 text-gray-900 hover:border-gray-300 hover:shadow-sm'
      }`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          {badge && badge > 0 && (
            <div className={`absolute top-2 right-2 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
              isActive 
                ? 'bg-white text-gray-900' 
                : 'bg-gray-900 text-white'
            }`}>
              {badge}
            </div>
          )}
          <h3 className={`text-[17px] font-bold mb-1 ${
            isActive ? 'text-white' : 'text-[#3d3d3d]'
          }`}>
            {title}
          </h3>
          <div className={`text-[15px] font-medium ${
            isActive ? 'text-gray-500' : 'text-gray-900'
          }`}>
            {badgeText || description}
          </div>
        </div>
        {icon && (
          <div className="ml-4 flex-shrink-0">
            <div className={`w-10 h-10 flex items-center justify-center ${
              isActive ? 'text-white' : 'text-gray-900'
            }`}>
              {icon}
            </div>
          </div>
        )}
      </div>
    </Link>
  );
};

NavigationCard.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node,
  isActive: PropTypes.bool.isRequired,
  badge: PropTypes.number,
  badgeText: PropTypes.string,
  onClick: PropTypes.func
};

export { NavigationCard };

